import React from "react";

const StartedBy = () => {
  return (
    <div className="startedByContainer">
      <div className="startedByImg">
        <img alt="image" src="/images/startedBy.png" />
      </div>
      <div className="startedByContent">
        <span className="startedByTitle">
          Started By A Trucker For Truckers
        </span>
        <span className="startedBySubTitle">
          Darshan Cheema (co-founder) was an owner operator. Harman Cheema and
          Harry Cheema (Sons of Darshan Cheema) both grew up around trucks and
          went on rides with Darshan every summer.
        </span>

        <span className="startedBySubTitle">
          In 2006 in Kent, Washington Darshan Cheema acquired his own
          operatingauthority. Just two years later Cheema Freightlines was
          running a fleet of 5 company trucks and 7 owner operators and now 325+
          trucks.
        </span>

        <span className="navDriveUs1">Drive with us</span>
      </div>
    </div>
  );
};

export default StartedBy;
